import React, { useState } from "react";
import "./RegistrationPage.css";
import { validateUser } from "../../api/validationApi"; 

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function RegistrationPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    enrollmentNumber: "",
    year: "",
    type: "alumni",
    role: "alumni", // Default to Alumni
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleToggle = (type) => {
    setFormData((prevData) => ({
      ...prevData,
      type: type,
      role: type, // Keep role same as type
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("📤 Submitted data:", formData);
  
    try {
      const updatedFormData = {
        ...formData,
        enrollmentNumber: formData.enrollmentNumber.trim(),
        firstName: formData.firstName.trim(),
        lastName: formData.lastName?.trim(),
        year: formData.year.trim(),
        type: formData.type,
      };
  
      const result = await validateUser(updatedFormData);
      console.log("📥 Response from Backend:", result);
  
      if (!result || result.error) {
        console.error("❌ Validation Failed: ", result);
        alert(result.error || `Validation failed: ${formData.type} not found`);
        return;
      }
  
      if (!result.user) {
        console.error("❌ Error: `user` object is missing in backend response", result);
        alert("Invalid response from server. Please try again.");
        return;
      }
  
      localStorage.setItem("role", formData.role);
      localStorage.setItem("userDetails", JSON.stringify({
        firstName: result.user["FIRST NAME"],
        lastName: result.user["LAST NAME"],
        enrollmentNumber: result.user["ENROLLMENT NO"],
        year: result.user["YEAR"], // if available
        role: formData.role
      }));
  
      console.log("🚀 Redirecting...");
      navigate(formData.type === "alumni" ? "/pages/alumni-details" : "/pages/student-details");
  
    } catch (error) {
      console.error("❌ Error during validation:", error);
      alert("An error occurred during validation.");
    }
  };

  return (
    <div className="registration">
      <form onSubmit={handleSubmit} className="form-container">
        <div className="toggle-container">
          <div className={`toggle-option ${formData.type === "student" ? "active" : ""}`} onClick={() => handleToggle("student")}>
            Student
          </div>
          <div className={`toggle-option ${formData.type === "alumni" ? "active" : ""}`} onClick={() => handleToggle("alumni")}>
            Alumni
          </div>
        </div>

        <h1 className="form-heading">Register as {formData.type === "student" ? "Student" : "Alumni"}</h1>

        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="First Name" />
        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" />
        <input type="text" name="enrollmentNumber" value={formData.enrollmentNumber} onChange={handleChange} required placeholder="Enrollment Number" />
        <input type="text" name="year" value={formData.year} onChange={handleChange} required placeholder={formData.type === "alumni" ? "Graduated Year" : "Graduating Year"} />

        <button type="submit" className="submit-button">
          Register
        </button>
        <p>
          Already have an account? <Link to="/pages/loginpage" className="highlighted-link">Login</Link>
        </p>
      </form>
    </div>
  );
}

export default RegistrationPage;
